<template>
  <v-menu
    bottom
    left
    min-width="200"
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        class="ml-2"
        min-width="0"
        text
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-account</v-icon>
      </v-btn>
    </template>

    <v-list
      :tile="false"
      flat
      nav
    >
      <template>
        <app-bar-item
          to="/components/profile/"
        >
          个人中心
        </app-bar-item>
        <app-bar-item
          @click.native="logout"
        >
          退出登录
        </app-bar-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'DefaultAccount',

    data: () => ({
    }),
    methods: {
      logout () {
        axios
          .post(process.env.VUE_APP_BASE_API + '/user/logout')
          .then(response => {
            if (response.data.code === 20000) {
              localStorage.removeItem('Authorization')
              this.$router.push('/login')
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
  }
</script>
